import { ApiUser, isAdminUser, isEmployeeUser } from 'auth/token';

import { CommunityOfferType } from 'typing/communityOffers';

export type CommunityOfferCapabilities = {
	view: boolean;
	create: boolean;
	edit: boolean;
	allowedTypes: CommunityOfferType[];
};

const isCommunityOfferStudent = (user?: ApiUser) => user?.type === 'STUDENT';

export const getCommunityOfferCapabilities = (
	user?: ApiUser,
): CommunityOfferCapabilities => {
	if (isAdminUser(user) || isEmployeeUser(user)) {
		return {
			view: true,
			create: true,
			edit: true,
			allowedTypes: ['BRIGADE', 'TUTORING'],
		};
	}
	if (isCommunityOfferStudent(user)) {
		return {
			view: true,
			create: true,
			edit: false,
			allowedTypes: ['TUTORING'],
		};
	}
	return { view: false, create: false, edit: false, allowedTypes: [] };
};

export const canEditCommunityOffer = (user?: ApiUser, authorId?: string) =>
	isEmployeeUser(user) ? user.id === authorId : isAdminUser(user);

export const canActivateCommunityOffer = (
	user: ApiUser | undefined,
	authorId: string,
	isVisible: boolean,
) =>
	!isVisible &&
	(isEmployeeUser(user) ? user.id === authorId : isAdminUser(user));

export const canDeactivateCommunityOffer = (
	user: ApiUser | undefined,
	authorId: string,
	isVisible: boolean,
) =>
	isVisible &&
	(isAdminUser(user) ||
		((isEmployeeUser(user) || isCommunityOfferStudent(user)) &&
			user?.id === authorId));

export const canCreateCommunityOfferResponse = (
	user: ApiUser | undefined,
	authorId: string,
	isVisible: boolean,
) =>
	isCommunityOfferStudent(user) && isVisible === true && user?.id !== authorId;

export const canViewOwnCommunityOfferResponses = (user?: ApiUser) =>
	isCommunityOfferStudent(user);

export const canViewCommunityOfferResponsesRoute = (user?: ApiUser) =>
	isAdminUser(user) || isEmployeeUser(user) || isCommunityOfferStudent(user);

export const canViewCommunityOfferResponses = (
	user: ApiUser | undefined,
	authorId: string,
) =>
	isAdminUser(user) ||
	((isEmployeeUser(user) || isCommunityOfferStudent(user)) &&
		user?.id === authorId);
